<template>
  <div v-show="loading" class="home">
    <van-popup v-model="show" @closed="closed" position="bottom" round :style="{ height: '60%' }">
      <div class="shop-popup">
        <div class="titlediv">
          <div class="cancel" @click="closed">取消</div>
          <div class="title">选择自提门店</div>
          <div class="title-placeholder"></div>
        </div>
        <div class="shop-scroll">
          <div
            v-for="(item, index) in shopList"
            :key="shopKey(item, index)"
            class="shop-card"
            @click="selectItem(index)">
            <div class="shop-name">{{ shopDisplayName(item) }}</div>
            <div class="shop-info">
              <div class="shop-addr">
                <van-icon name="location-o" size="0.9rem" color="#999" />
                <span>{{ item.address }}</span>
              </div>
              <div v-if="getKm(item.gap)" class="shop-distance">{{ getKm(item.gap) }}</div>
            </div>
            <a v-if="item.phone" class="shop-phone" :href="'tel:' + item.phone" @click.stop>
              <van-icon name="phone-o" size="0.9rem" color="#ee0a24" />
              <span>{{ item.phone }}</span>
            </a>
          </div>
          <div v-if="!shopList || shopList.length === 0" class="shop-empty">暂无可用门店</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
export default {
  name: "",
  props: {
    shopList: {
      type: Array,
    },
  },
  data() {
    return {
      selectIndex: -1,
      show: true,
      loading: true,
      value: 1,
    };
  },
  created() {
    this.loading = true
  },

  components: {},
  methods: {
    shopDisplayName(item) {
      return (item && (item.shop_name || item.shopName)) || "门店";
    },
    shopKey(item, index) {
      return (item && (item.shop_id || item.shopId)) || index;
    },
    getKm(gap) {
      if (!gap || gap === '0.0') {
        return ''
      }
      if (gap > 1000) {
        return '>1000km'
      } else {
        return gap + 'km'
      }
    },
    closed() {
      this.$emit("closed", false);
    },
    // 步进器事件
    change(value) {
      this.value = value;
    },
    // 购买
    buy() {
      // console.log(this.good);
      // 添加一个count属性
      if (localStorage.getItem("nickname")) {
        // this.$set(this.good, "count", this.value);
        let obj = {
          index: this.selectIndex,
          cont: this.value
        }
        this.$emit('seleceItem', obj)
      } else {
        Dialog.confirm({
          title: "未登录",
          message: "是否前去登陆",
        })
          .then(() => {
            this.$router.push("/Login");
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    getPhone(phone) {
      return this.$utils.formPhone(phone);
    },
    selectItem(index) {
      this.selectIndex = index
      const item = this.shopList && this.shopList[index]
      if (item) {
        this.$emit('seleceShopItem', item)
      }
    },
    sure() {
      if (this.selectIndex > -1) {
        let item = this.shopList[this.selectIndex]
        this.$emit('seleceShopItem', item)
      } else {
        Toast('请先选择商家地址')
      }
    }
  },
  mounted() {

  },
  computed: {},
  watch: {},
};
</script>

<style lang='scss' scoped>
.shop-popup {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
}

.titlediv {
  flex-shrink: 0;
  height: 3rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 1rem;
  background: #fff;

  .cancel {
    margin-left: 1rem;
    color: #666;
  }

  .title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #323233;
  }

  .title-placeholder {
    width: 3rem;
  }
}

.shop-scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0.8rem;
}

.shop-card {
  background-color: #fff;
  border-radius: 0.8rem;
  padding: 1rem;
  margin-bottom: 0.6rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  &:active {
    background-color: #f9f9f9;
  }
}

.shop-name {
  font-size: 1.05rem;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
  margin-bottom: 0.6rem;
  word-break: break-word;
}

.shop-info {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.8rem;
}

.shop-addr {
  flex: 1;
  display: flex;
  align-items: flex-start;
  gap: 0.3rem;
  font-size: 0.85rem;
  color: #999;
  line-height: 1.5;

  span {
    word-break: break-word;
  }

  .van-icon {
    flex-shrink: 0;
    margin-top: 0.15rem;
  }
}

.shop-distance {
  flex-shrink: 0;
  font-size: 0.85rem;
  color: #ee0a24;
  font-weight: 500;
  white-space: nowrap;
}

.shop-phone {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: 0.6rem;
  padding-top: 0.6rem;
  border-top: 1px dashed #f0f0f0;
  font-size: 0.85rem;
  color: #323233;
  text-decoration: none;
}

.shop-empty {
  padding: 2rem 0;
  text-align: center;
  font-size: 0.85rem;
  color: #969799;
}
</style>
